import React from 'react';
import { Snackbar } from '@material-ui/core';

import { useDispatch, useSelector } from 'react-redux';
import State from '../states/State';
import slice from '../states/snackbar/slice';
import MuiAlert from '@material-ui/lab/Alert';

const getDisplaySeverity = (severity: string) => {
  switch (severity) {
    case 'success':
    case 'error':
    case 'warning':
      return severity;
    default:
      return 'info';
  }
}

type PeSnackBarProps = {};

const PeSnackBar: React.FC<PeSnackBarProps> = props => {
  const state = useSelector((state: State) => {
    const snackbar = state.snackbar
    return ({
      snackbar
    });
  });

  const dispatch = useDispatch();
  const severity = getDisplaySeverity(state.snackbar.alert.severity);

  const handleClose = () => {
    dispatch(slice.actions.updateSnackBar(false));
  };

  return <Snackbar
    open={state.snackbar.isOpen}
    autoHideDuration={3000}
    onClose={handleClose}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
    <MuiAlert
      onClose={handleClose}
      variant='filled'
      severity={severity}>
        {state.snackbar.alert.message}
    </MuiAlert>
  </Snackbar>
}

export default PeSnackBar;